import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
export default class SiteSettingsApi {}
SiteSettingsApi.fetch = () => {
  return http.get(`content-settings/v1/site-settings/by-portal-id/${PortalIdParser.get()}`);
};